import { useQuery } from "@tanstack/react-query";
import { queryTags } from "supabase/events";

export const useQueryTags = () => {
  const {
    isLoading,
    isError,
    error,
    data: tags,
  } = useQuery({
    queryKey: ["tags"],
    queryFn: () => {
      return queryTags();
    },
  });

  return { isLoading, isError, error, tags };
};
